<template>
    <div class="btns-cards-view">
        <p>{{flatsWords.flats_filters_names.view}}</p>
        <div class="btns">
            <div class="item" :class="{active: !gridView}">
                <a href="#" class="btn-view-item btn-view-list btn-change-cards-view" @click.prevent="setGridView(false)">
                    <svgIcon name="list" />
                </a>
            </div>
            <div class="item" :class="{active: gridView}">
                <a href="#" class="btn-view-item btn-view-grid btn-change-cards-view" @click.prevent="setGridView(true)">
                    <svgIcon name="grid" />
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'sale-CRM-flats-btns',
        components: {
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            flatsWords: 'loadFlatsWords',
			gridView: 'loadLandFlatsGridView',
        }),
        methods: {
            setGridView(param) { 
				this.$store.commit('gridView', param);
            },
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/flats-crm/flats-crm-btns.scss';
    @import '@/styles/components/flats-crm/respond/flats-crm-btns-respond.scss';
    // @import '@/styles/respond/sales/sales-land-partials/land-flats-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>